export { default } from './ImageWithCaption';
export * from './ImageWithCaption';
